import { SidebarDocument } from './types';

export function isDocumentPreviewEnabled(document: SidebarDocument) {
  const fileName = document.fileName ?? '';

  return (
    document.virusFree === true &&
    (document.mimetype === 'application/pdf' ||
      fileName.toLowerCase().endsWith('.pdf'))
  );
}
